import { render, staticRenderFns } from "./term-reservation.vue?vue&type=template&id=2e1627c1&"
import script from "./term-reservation.vue?vue&type=script&lang=js&"
export * from "./term-reservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports